import { useMutation } from '@apollo/client'
import { Descriptions, Row, Space, Tabs, Tag, Typography } from 'antd'
import { uniqBy } from 'lodash'
import { useCallback } from 'react'
import { SOCIETE_UPDATE_MUTATION } from '../../apollo/mutation/societe.mutation'
import { D4_Societe } from '../../types'
import TableDemandeDeRappel from '../TableDemandeDeRappel'
import Actions from './Actions'
import ChequesTable from './ChequesTable'
import Equipe from './Equipe'
import Lots from './Lots'
import StyledDescription from './StyledDescription'

const { TabPane } = Tabs

const SocieteDescription = ({ societe, onChange }: { societe: D4_Societe; onChange?: () => void }) => {
  const [update] = useMutation(SOCIETE_UPDATE_MUTATION)

  const handleChange = useCallback(
    (key: string) => (value: string) => {
      update({
        variables: {
          id: societe.id,
          data: { [key]: value },
        },
      })
      onChange?.()
    },
    [onChange, societe.id, update]
  )

  if (!societe) return null

  const lots = uniqBy(societe.coproprietaire?.lot_coproprietaires, 'lot.copropriete.id')

  return (
    <div style={{ backgroundColor: 'white', padding: '10px', borderRadius: '5px' }}>
      <Typography.Title level={4}>
        <Row justify="space-between" align="middle">
          <Space>
            <span>{societe.raisonsociale}</span> <Lots lots={societe?.coproprietaire?.lot_coproprietaires} />
          </Space>
          <Tag color={societe.comptevision?.actif ? 'green' : 'red'}>
            {societe.comptevision?.actif ? 'Actif' : 'Inactif'}
          </Tag>
        </Row>
      </Typography.Title>
      <Actions coproprietaire={societe.coproprietaire} actif={societe.comptevision?.actif ?? false} />
      <StyledDescription size="small" bordered column={{ xxl: 3, xl: 2, lg: 2, md: 1, sm: 1, xs: 1 }}>
        <Descriptions.Item label="Raison Sociale">
          <Typography.Text editable={{ onChange: handleChange('raisonsociale') }}>
            {societe.raisonsociale}
          </Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Mail1">
          <Typography.Text editable={{ onChange: handleChange('mail1') }}>{societe.mail1}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Mail2">
          <Typography.Text editable={{ onChange: handleChange('mail2') }}>{societe.mail2}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Fixe">
          <Typography.Text editable={{ onChange: handleChange('telfixe') }}>{societe.telfixe}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Portable">
          <Typography.Text editable={{ onChange: handleChange('telportable') }}>{societe.telportable}</Typography.Text>
        </Descriptions.Item>
        <Descriptions.Item label="Équipe">
          <Equipe lots={lots} />
        </Descriptions.Item>
      </StyledDescription>
      <Tabs defaultActiveKey="rappel" type="card" style={{ marginBottom: 0 }}>
        <TabPane tab="Rappel" key="rappel">
          <TableDemandeDeRappel emetteurId={societe?.representant_id} />
        </TabPane>
        <TabPane tab="Cheque" key="cheque">
          <ChequesTable coproprietaireId={societe.coproprietaire?.id} />
        </TabPane>
      </Tabs>
    </div>
  )
}

export default SocieteDescription
